import React, {Component, Fragment} from 'react'
import tinymce from 'tinymce'
import autobind from 'autobind-decorator'
import './plugins/tistory-replacer'
import './plugins/tistory-attacher'
import './plugins/tistory-plugins'
import './plugins/tistory-mode'
import GooglePhotosDialog from "../plugins/GooglePhotos/GooglePhotosDialog";
import CategorySelect from "../CategorySelect";
import TemplateDialog from "./control/TemplateDialog";
import PostTitle from "../PostTitle";
import ContentEditor from "./ContentEditor";
import RevenueDialog from "./control/RevenueDialog";
import {enabledAdFit} from "../../../lib/RevenueUtils";

const EDITOR_ID = 'editor-tistory';

class RichEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRng: {},
      openGooglePhotos: false,
      openTemplate: false,
      openRevenue: false,
    };
  }

  @autobind
  handleToggleGooglePhotos() {
    this.setState({
      openGooglePhotos: !this.state.openGooglePhotos
    })
  }

  @autobind
  handleToggleTemplate() {
    this.setState({
      openTemplate: !this.state.openTemplate
    })
  }

  @autobind
  handleToggleRevenue() {
    this.setState({
      openRevenue: !this.state.openRevenue
    })
  }

  @autobind
  handleApplyRevenue(content) {
    const {lastRng} = this.state;
    const editor = tinymce.activeEditor;
    editor.selection.setRng(lastRng);
    const revenueElement = editor.dom.$('figure[data-ke-type="revenue"]');

    if(revenueElement && revenueElement.length > 0)
      alert('본문 중간에 이미 추가한 광고가 있습니다.');
    else
      editor.execCommand('mceInsertContent', false, content);

    this.handleToggleRevenue();
  }

  @autobind
  handleApplyTemplate(content) {
    const {lastRng} = this.state;
    const editor = tinymce.activeEditor;
    editor.selection.setRng(lastRng);
    editor.execCommand('mceInsertContent', false, content);
    this.handleToggleTemplate();
  }

  @autobind
  handleOpenTemplate(rng) {
    this.setState({
      lastRng: rng
    });
    this.handleToggleTemplate();
  }

  @autobind
  handleOpenRevenue(rng) {
    this.setState({
      lastRng: rng
    });
    this.handleToggleRevenue();
  }

  render() {
    const {
      openGooglePhotos,
      openTemplate,
      openRevenue
    } = this.state;

    return (
      <Fragment>

        <CategorySelect/>

        <PostTitle/>

        <ContentEditor
          id={EDITOR_ID}
          onToggleGooglePhotos={this.handleToggleGooglePhotos}
          onOpenTemplate={this.handleOpenTemplate}
          onOpenRevenue={this.handleOpenRevenue}
        />

        <GooglePhotosDialog
          open={openGooglePhotos}
          onClose={this.handleToggleGooglePhotos}
          onSelectImage={(url) => {
            console.log("select image", url)
          }}
        />

        <TemplateDialog
          open={openTemplate}
          onClose={this.handleToggleTemplate}
          onApply={this.handleApplyTemplate}
        />
        {enabledAdFit && <RevenueDialog
          open={openRevenue}
          onClose={this.handleToggleRevenue}
          onApply={this.handleApplyRevenue}
        />
        }

      </Fragment>
    )
  }
}

export default RichEditor
